import TaxDocumentSummary from './TaxDocumentSummary';
export { Skeleton } from './Skeleton';
export default TaxDocumentSummary;
